import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const GenericModal = (props) => {
	return (
		<Modal show={props.isDisplayed} onHide={() => props.handleModalClose(false)}>
			<Modal.Header closeButton>
				<Modal.Title>{props.title}</Modal.Title>
			</Modal.Header>
			<Modal.Body><pre>{props.message}</pre></Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={() => props.handleModalClose(false)}>
					{props.closeButton || 'Close'}
				</Button>
				{props.showConfirmButton && props.itemId ? 
					<Button id="btnGenericModalConfirm" variant="primary" tabIndex="7" onClick={() => props.handleModalConfirm(props.itemId)}>
						{props.confirmButton || 'Confirm'}
					</Button> : ''
				}
			</Modal.Footer>
		</Modal>
	);
}

export default GenericModal;